import { render, staticRenderFns } from "./OrgViewOrgInfoCard.vue?vue&type=template&id=8dd864c2&"
import script from "./OrgViewOrgInfoCard.vue?vue&type=script&lang=js&"
export * from "./OrgViewOrgInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports